import axios from "axios";
import { baseUrl, epmsBaseUrl } from "../constant/Config";
// import { logout } from "../utils/CommonFunction";

const newBaseUrl = (baseUrlToUse: string) => {
  if (window.location.protocol === "http:") {
    let newBaseUrl: string | undefined = baseUrlToUse;
    newBaseUrl = newBaseUrl?.replace("https", "http");
    return newBaseUrl;
  } else {
    return baseUrlToUse;
  }
};
const getDynamicBaseUrl = (endPoint: string) => {
  if (endPoint === "epVerifyLinkOtp" || endPoint === "epGenerateOtp") {
    return newBaseUrl(epmsBaseUrl);
  }

  return newBaseUrl(baseUrl);
};

export const getRequest = async (endPoint: string) => {
  try {
    const response = await axios({
      url: `${getDynamicBaseUrl(endPoint)}${endPoint}`,
      method: "get",
      headers: {
        "Content-Type": "application/json",
        // Connection: "close",
        Authorization: "Bearer " + (window as any).authToken,
      },
    });
    return response;
  } catch (error: any) {
    console.log("Error in getRequest:", error);
    if (error.response?.status === 403) {
      console.log("Error 403: Unauthorized access");
      // logout("network");
    }
    throw error;
  }
};

export const postRequest = async (endPoint: string, data: {}) => {
  try {
    const response = await axios({
      url: `${getDynamicBaseUrl(endPoint)}${endPoint}`,
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        // Connection: "close",
        Authorization: "Bearer " + (window as any).authToken,
      },
      data: data,
      // timeout: requestTimeout,
    });
    return response;
  } catch (error: any) {
    if (error.response?.status === 403) {
      // logout("network");
    }
    throw error;
  }
};
